import { createAction, props } from '@ngrx/store';
import { TVat } from './vats.state';

export enum VatsActions {
  VatsRequested = '[Vats] Vats Requested',
  VatsLoaded = '[Vats] Vats Loaded',
  VatsError = '[Vats] Vats Error'
}

export const VatsRequested = createAction(VatsActions.VatsRequested);

export const VatsLoaded = createAction(VatsActions.VatsLoaded, props<{ vatsInfo: TVat[]}>());

export const VatsError = createAction(VatsActions.VatsError);
